import { Navigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { ReverLoading } from '@itsrever/design-system'
import { useStorePlatform } from '@/hooks'
import {
  nonReturnableListsFor,
  useNonReturnableLists
} from '@/application/manage-return-conditions'
import { useAppSelector } from '@/redux/hooks'
import { Roles } from '@/utils'
import { NonReturnableForm } from '@/ui/components/settings-components'
import { LoadError, NavigationTabs, PageHeader } from '@/ui/shared'
import {
  isDashboardBlocked,
  useFeatureFlag
} from '@/application/use-feature-flag'
import { BlockedDashboardOverlay } from '@/ui/components/overlays/blocked-dashboard-overlay'
import { useReturnConditionsTabs } from './configuration-tabs'

export default function NonReturnable() {
  const { t } = useTranslation()
  const { isFlagEnabled } = useFeatureFlag(isDashboardBlocked, {
    pageName: 'configuration'
  })
  const platform = useStorePlatform()
  const role = useAppSelector((s) => s.userApi.getMe.response.user?.role)
  const canEdit = role === Roles.ReadWrite
  const tabs = useReturnConditionsTabs()
  const {
    ecommerceId,
    lists,
    setLists,
    originalLists,
    loading,
    loadFailed,
    reload,
    saving,
    save
  } = useNonReturnableLists()

  if (!platform || loading) return <ReverLoading />
  // A platform whose evaluator compares none of the lists has nothing to edit here.
  if (nonReturnableListsFor(platform).length === 0)
    return <Navigate to="/configuration/return-conditions" replace />
  return (
    <>
      <NavigationTabs tabs={tabs} selectedIndex={2} />
      {isFlagEnabled && <BlockedDashboardOverlay />}
      <PageHeader
        title={t('page_titles./configuration/non-returnable')}
        description={t('non_returnable.description')}
      />
      <div className="flex flex-col gap-4 px-7 py-4">
        <div className="max-w-[1100px]">
          {loadFailed ? (
            <LoadError
              message={t('non_returnable.load_error')}
              onRetry={reload}
            />
          ) : (
            <NonReturnableForm
              ecommerceId={ecommerceId}
              platform={platform}
              lists={lists}
              originalLists={originalLists}
              setLists={setLists}
              canEdit={canEdit}
              saving={saving}
              onSave={save}
            />
          )}
        </div>
      </div>
    </>
  )
}
